import axios from 'axios'
import { getAccessToken } from './auth'

export const SERVICE_AHORRO_YA_BASE_URL = process.env.GATSBY_URL_BASE_AFFILIATES
export const SUBSCRIPTION_KEY = process.env.GATSBY_SUBSCRIPTION_KEY_AHORRO_YA

export const SERVICE_OTP_VALIDATION = '/v1/otp/Validation'
export const SERVICE_OTP_GENERATION = '/v1/otp/generar'
export const SERVICE_AFFILIATE = '/affiliate/v1'
export const SERVICE_VALIDATION = '/validation'

export const CODES_RESPONSE = {
  'NCL-NR-003': 'NO_CLIENT',
  'NCL-NR-004': 'FIVE_YEARS',
  'NCL-NR-005': 'NO_APV',
  'NCL-SR-001': 'CLIENT',
  'NCL-NR-001': 'NO_REGISTERED',
  '1': 'RECAPTCHA_ERROR',
  ERROR: 'ERROR',
}

const instance = axios.create({
  baseURL: SERVICE_AHORRO_YA_BASE_URL,
  responseType: 'json',
})

export async function serviceRequest(method, endpoint, data, token = "", fromRetry = false) {
  try {
    // Obtener el token de acceso desde el almacenamiento local
    let accessToken = localStorage.getItem('access_token')
    // Si no hay token en el almacenamiento local, obtenerlo desde el servicio
    if (!accessToken) {
      accessToken = await getAccessToken('ahorroya')
    }
    // Añadir el token de acceso en el header de la petición
    instance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
    // Configurar el header con la subscription key
    let config = {
      headers: {
        'Ocp-Apim-Subscription-Key': SUBSCRIPTION_KEY,
        'Captcha-Response': token
      }
    } 
    // Hacer la petición al endpoint
    let response
    if (method === 'GET') {
      response = await instance.get(endpoint, config)
    } else if (method === 'POST') {
      response = await instance.post(endpoint, data, config)
    } else {
      throw new Error('Method not allowed')
    }
    return response.data
  } catch (error) {
    // Si el endpoint devuelve un error de autenticación, obtener un nuevo token y volver a intentar la petición
    if (error.response.status === 401) {
      localStorage.removeItem('access_token')
      const newAccessToken = await getAccessToken('ahorroya')
      localStorage.setItem('access_token', newAccessToken)
      return !fromRetry && serviceRequest(method, endpoint, data, token, true)
    } else {
      console.error(error)
      return { code: 'ERROR' }
    }
  }
}


